import React from 'react';
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  tone?: 'light' | 'dark';
};
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  tone = 'light'
}: SectionHeadingProps) {
  const isDark = tone === 'dark';
  return <header className="mx-auto max-w-2xl text-center" data-id="element-59" data-mp="3k06xtxg0ixzu">
      {eyebrow ? <p className={`text-[11px] font-extrabold uppercase tracking-[0.16em] sm:text-xs ${isDark ? 'text-navy-200' : 'text-brick-600'}`} data-id="element-60" data-mp="3k29kq8lvcb0c">
          {eyebrow}
        </p> : null}
      <h2 className={`mt-2.5 text-balance font-display text-[26px] font-bold leading-[1.15] sm:text-4xl lg:text-[42px] ${isDark ? 'text-white' : 'text-navy-900'}`} data-id="element-61" data-mp="1uttrzn0x4hl">
        {title}
      </h2>
      {subtitle ? <p className={`mx-auto mt-3.5 max-w-xl text-[15px] font-medium leading-relaxed sm:text-lg ${isDark ? 'text-navy-100' : 'text-navy-600'}`} data-id="element-62" data-mp="uhof0yro07w4">
          {subtitle}
        </p> : null}
    </header>;
}